import React from "react"
import propTypes from "prop-types"
import { Link } from "react-router-dom"
import { Button } from "reactstrap"

const ProductsItemList = ({ item, canDelete, canEdit, openEditModal, openDeleteModal }) => {
  function currencyFormatter({ currency, value }) {
    const numericValue = Number(value)
    if (!Number.isFinite(numericValue)) return "--"

    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    })
    return formatter.format(numericValue)
  }

  const productPrices = Array.isArray(item?.prices) ? item.prices : []

  const normalizeText = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")

  const getPriceByAliases = (aliases) => {
    const normalizedAliases = aliases.map(normalizeText)

    return productPrices.find((priceItem) => {
      const priceName = normalizeText(priceItem?.price?.name)
      const priceIdentifier = normalizeText(priceItem?.price?.identifier)

      return normalizedAliases.includes(priceName) || normalizedAliases.includes(priceIdentifier)
    })
  }

  const listPrice = getPriceByAliases(["P1", "Lista", "Precio de Lista", "Precio Lista"])
  const wholesalePrice = getPriceByAliases(["P2", "Mayoreo", "Precio de Mayoreo", "Precio Mayoreo"])

  const styleCenterTable = { textAlign: "center", verticalAlign: "middle" }
  const styleLeftTable = { textAlign: "left", verticalAlign: "middle" }

  const renderEditButton = () => {
    if (!canEdit) {
      return null
    }

    return (
      <Button color="primary" className="m-1" onClick={() => openEditModal(item.id)}>
        <i className="fa fa-edit" />
      </Button>
    )
  }

  const renderDeleteButton = () => {
    if (!canDelete) {
      return null
    }

    return (
      <Button color="danger" onClick={() => openDeleteModal(item)} title="Desactivar producto">
        <i className="fa fa-trash" />
      </Button>
    )
  }

  return (
    <tr key={item.id}>
      <td style={styleLeftTable}>
        <Link to={{ pathname: `/products/${item.id}` }}>{item.bar_code}</Link>
      </td>
      <td style={styleLeftTable}>{item.name}</td>
      <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
        currency: "USD", value: listPrice?.amount })}</td>
      <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
        currency: "USD", value: wholesalePrice?.amount })}</td>
      <td style={styleCenterTable}>{item.sat_code || "--"}</td>
      <td style={styleCenterTable} className="money-cell">{currencyFormatter({ 
        currency: "USD", value: item.cost })}</td>
      <td style={styleCenterTable} className="text-center">
        {renderEditButton()}
        {renderDeleteButton()}
      </td>
    </tr>
  )
}

ProductsItemList.propTypes = {
  item: propTypes.object,
  canDelete: propTypes.bool,
  canEdit: propTypes.bool,
  openEditModal: propTypes.func,
  openDeleteModal: propTypes.func,
}

export default ProductsItemList
